const serviceData = [
  {
    id: 1,
    title: "Installation and Setup",
    icon: "ri-tools-line",
    desc: "Professional installation of solar panels, inverters, and mounting systems. Ensure proper wiring, configuration, and integration with existing electrical systems.",
  },

  {
    id: 2,
    title: "Maintenance and Repairs",
    icon: "ri-tools-line",
    desc: "Offer regular maintenance services to ensure optimal performance. Provide troubleshooting and repair services for any issues that may arise.",
  },

  {
    id: 3,
    title: "Energy Storage Solutions",
    icon: "ri-battery-charge-line",
    desc: "Offer battery storage options to store excess solar energy. Provide appliances to enable integrated solar energy storage systems.",
  },

  {
    id: 4,
    title: "Site Survey and Security Assessment",
    icon: "ri-shield-line",
    desc: "Conduct thorough site surveys to identify security vulnerabilities. Providing expert recommendations on camera placement and system design.",
  },

  {
    id: 5,
    title: "Installation and Configuration",
    icon: "ri-camera-line",
    desc: "Professional installation of CCTV cameras, DVRs/NVRs, and related equipments. Ensuring proper configuration and integration with existing security systems.",
  },

  {
    id: 6,
    title: "Remote Monitoring and Access",
    icon: "ri-remote-control-line",
    desc: "Set up remote monitoring capabilities for real-time access via smartphones or computers. Providing training on how to use remote access and monitoring tools.",
  },
];

export default serviceData;
